<base-dialog>
  <div title>
    <h2>UNIDAD DE NEGOCIO</h2>
  </div>

  <div close>
    <button mat-icon-button color="warn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div content>
    <mat-tab-group
      mat-stretch-tabs
      class="mat-elevation-z1"
      [selectedIndex]="tabSelected"
      (selectedTabChange)="validarTab($event)"
    >
      <mat-tab label="Dirección">
        <div class="business_form formulario">
          <ng-template matTabContent>
            <business-direction
              [businessData]="idsBusiness"
              [formData]="formDataBusiness"
              (formValid)="businessFormValid($event)"
            />
          </ng-template>
        </div>
      </mat-tab>
      <mat-tab label="Naturaleza Económica" [disabled]="!isEnabledEconomic">
        <div class="business_form formulario">
          <ng-template matTabContent>
            <app-economic-nature
              [businessUnitId]="idsBusiness.businessUnitId"
              [formData]="formDataEconomic"
              (formValid)="economicFormValid($event)"
            />
          </ng-template>
        </div>
      </mat-tab>
      <mat-tab label="Punto Emisión" [disabled]="!isEnabledPoint">
        <div class="formulario">
          <point-emission
            [businessUnitId]="idsBusiness.businessUnitId"
            (isActiveBtn)="isActiveBtn = $event"
          />
        </div>
      </mat-tab>
      <mat-tab label="Bodega" [disabled]="!isEnabledWarehouse">
        <div class="formulario">
          <app-warehouse
            [businessUnitId]="idsBusiness.businessUnitId"
            (isActiveBtn)="isActiveBtn = $event"
          />
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div actions>
    <button
      actions
      mat-raised-button
      (click)="submit()"
      color="primary"
      class="submit-button w-button"
      [disabled]="!isActiveBtn"
    >
      <div class="loadingComponent" *ngIf="isLoading">
        <app-loading [isLoading]="isLoading" />
      </div>
      <span *ngIf="!isLoading">{{ txtBtn }}</span>
    </button>
  </div>
</base-dialog>
